module.exports = __webpack_public_path__ + "img/i_15.8048d6df.png";